import App from '@/App.vue';
import '@/publicCss/reset.less';
import '@/publicCss/common.less';
import '@/publicCss/modal.less';
import '@/publicCss/pub.less';
import router from '@/router';
import { twemoji, initTwemoji } from '@/directives/twemoji';
import { startBootstrap } from '@/utils/bootstrap';

function canSelect(target: EventTarget | null) {
    if (!(target instanceof Element)) {
        return false;
    }

    return Boolean(target.closest("input, textarea, select, [contenteditable='true']"));
}

document.addEventListener('selectstart', (event) => {
    if (!canSelect(event.target)) {
        event.preventDefault();
    }
}, true);

document.addEventListener('dragstart', (event) => {
    if (!canSelect(event.target)) {
        event.preventDefault();
    }
}, true);

document.addEventListener('mousedown', (event) => {
    if (!canSelect(event.target)) {
        const selection = window.getSelection();

        if (selection) {
            selection.removeAllRanges();
        }
    }
}, true);

console.log("%c main.ts==>当前环境：", "background:pink", import.meta.env.VITE_APP_ENV);
console.log("%c main.ts==>当前域名：", "background:pink", import.meta.env.VITE_API_BASE_URL);
console.log("%c main.ts==>埋点域名：", "background:pink", import.meta.env.VITE_LOG_BASE_URL);

// 应用主入口：挂载 Vue 与 Pinia，并引入全局公共样式。
const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// v-twemoji：Win7 等无彩色 emoji 字体的系统上，用本地 SVG 图片替换 emoji
app.directive('twemoji', twemoji);

const appStore = useAppStore();

// 启动引导：拿渠道信息 + 拉云控域名，尽量早于任何业务请求。
// 不 await：界面照常渲染，业务请求会在 http.ts 拦截器里等域名确定。
startBootstrap();

router.afterEach((to) => {
    appStore.syncRoute(to.name);
});

router.isReady().then(() => {
    appStore.syncRoute(router.currentRoute.value.name);
    app.mount('#app');
    // 全局把 emoji 替换成本地 SVG 图片（Win7 无彩色 emoji 字体时也能正常显示）
    initTwemoji(document.getElementById('app') || document.body);
});
